// extracted by mini-css-extract-plugin
export var linkText = "_or-0";